define('views/components/product_category/product_categories',['require','views/base/collection_view','views/components/product_category/product_category_list','text!templates/base/collection.html'],function(require){

    var BaseCollectionView = require('views/base/collection_view');
    var ListView = require('views/components/product_category/product_category_list');

    var temp = require("text!templates/base/collection.html");
    return BaseCollectionView.extend({
        template: _.template(temp),
        className: 'grid-container product-category-grid-container',

        onRender: function () {
            this.ListContainer.show(new ListView({
                collection: this.collection
            }));
        }
    });
});

